var _path, _path2, _path3, _path4, _g, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDigiforumStripe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 69,
    viewBox: "0 0 67 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.3088 48.1636C54.8541 51.7279 52.5002 54.8496 49.4909 57.2053C46.4816 59.5611 42.9263 61.0653 39.1933 61.562C35.4602 62.0588 31.6852 61.5301 28.2592 60.0307C24.8332 58.5312 21.8808 56.1156 19.7079 53.0341L24.2756 49.6319C25.8709 51.8942 28.0383 53.6676 30.5534 54.7684C33.0686 55.8691 35.8399 56.2573 38.5805 55.8926C41.321 55.5279 43.9311 54.4237 46.1403 52.6942C48.3496 50.9648 50.0776 48.673 51.1455 46.0563L56.3088 48.1636Z",
    fill: "url(#paint0_linear_201_3120)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3088 46.1636C53.8541 49.7279 51.5002 52.8496 48.4909 55.2053C45.4816 57.5611 41.9263 59.0653 38.1933 59.562C34.4602 60.0588 30.6852 59.5301 27.2592 58.0307C23.8332 56.5312 20.8808 54.1156 18.7079 51.0341L23.2756 47.6319C24.8709 49.8942 27.0383 51.6676 29.5534 52.7684C32.0686 53.8691 34.8399 54.2573 37.5805 53.8926C40.321 53.5279 42.9311 52.4237 45.1403 50.6942C47.3496 48.9648 49.0776 46.673 50.1455 44.0563L55.3088 46.1636Z",
    fill: "#FC728B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.997 25.817C9.90133 25.6768 9.11706 24.6716 9.36302 23.5948C10.0644 20.5241 11.4659 17.6375 13.4777 15.1448C15.9145 12.1257 19.1579 9.79408 22.8721 8.39161C26.5862 6.98914 30.6361 6.56677 34.6021 7.16825C37.8725 7.66423 40.9878 8.84149 43.731 10.6069C44.6867 11.222 44.8163 12.5342 44.0808 13.4006L42.9235 14.7638C42.2292 15.5817 41.0187 15.6944 40.1033 15.1348C38.1713 13.9539 36.0028 13.1623 33.7325 12.818C30.8209 12.3765 27.8478 12.6865 25.1211 13.7161C22.3944 14.7457 20.0133 16.4574 18.2244 18.6739C16.8607 20.3635 15.879 22.2996 15.3312 24.3611C15.0475 25.4286 14.0586 26.2087 12.963 26.0685L10.997 25.817Z",
    fill: "#A79EDF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8594 45.983C16.1594 51.1832 21.3323 54.9157 27.3076 56.4082C33.283 57.9007 39.6034 57.0389 44.961 54.0012C50.3186 50.9635 54.3034 45.9823 56.0907 40.0885C57.878 34.1946 57.3312 27.8392 54.5632 22.3374C51.7952 16.8355 47.0181 12.6084 41.2203 10.5306C35.4224 8.4528 29.0477 8.68346 23.4152 11.1748C17.7827 13.6662 13.3235 18.2276 10.9605 23.9151C8.59736 29.6026 8.51121 35.9809 10.7198 41.7301L15.6734 39.8272C13.9532 35.3491 14.0203 30.3811 15.8609 25.9511C17.7015 21.5212 21.1747 17.9683 25.5618 16.0278C29.9489 14.0873 34.9141 13.9077 39.43 15.526C43.9459 17.1444 47.6668 20.4369 49.8227 24.7223C51.9787 29.0076 52.4047 33.9578 51.0125 38.5485C49.6204 43.1392 46.5167 47.019 42.3436 49.385C38.1706 51.7511 33.2477 52.4223 28.5936 51.2598C23.9394 50.0973 19.9103 47.1901 17.34 43.1397L12.8594 45.983Z",
    fill: "url(#paint1_linear_201_3120)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_201_3120)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33.2847,
    cy: 33.2371,
    r: 21,
    fill: "url(#paint2_linear_201_3120)",
    shapeRendering: "crispEdges"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.909 38.3963C26.8181 38.3963 25.8551 38.1208 25.0198 37.5696C24.1846 37.0128 23.5312 36.2287 23.0596 35.2173C22.588 34.2003 22.3522 32.9986 22.3522 31.6122C22.3522 30.2372 22.588 29.0441 23.0596 28.0327C23.5312 27.0213 24.1874 26.2401 25.0283 25.6889C25.8693 25.1378 26.8408 24.8622 27.9431 24.8622C28.7954 24.8622 29.4687 25.0043 29.963 25.2884C30.463 25.5668 30.8437 25.885 31.1051 26.2429C31.3721 26.5952 31.5795 26.885 31.7272 27.1122H31.8977V20.6691H33.909V38.1236H31.9658V36.1122H31.7272C31.5795 36.3509 31.3693 36.652 31.0965 37.0156C30.8238 37.3736 30.4346 37.6946 29.9289 37.9787C29.4232 38.2571 28.7499 38.3963 27.909 38.3963ZM28.1818 36.5895C28.9886 36.5895 29.6704 36.3793 30.2272 35.9588C30.784 35.5327 31.2073 34.9446 31.4971 34.1946C31.7869 33.4389 31.9318 32.5668 31.9318 31.5781C31.9318 30.6009 31.7897 29.7458 31.5056 29.0128C31.2215 28.2742 30.8011 27.7003 30.2443 27.2912C29.6874 26.8764 28.9999 26.6691 28.1818 26.6691C27.3295 26.6691 26.6193 26.8878 26.0511 27.3253C25.4886 27.7571 25.0653 28.3452 24.7812 29.0895C24.5028 29.8281 24.3636 30.6577 24.3636 31.5781C24.3636 32.51 24.5056 33.3566 24.7897 34.1179C25.0795 34.8736 25.5056 35.4759 26.0681 35.9247C26.6363 36.3679 27.3408 36.5895 28.1818 36.5895Z",
    fill: "#ECECEC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1704 33.1236C39.9829 32.5497 39.7357 32.0355 39.4289 31.581C39.1278 31.1208 38.767 30.7287 38.3465 30.4048C37.9318 30.081 37.4602 29.8338 36.9318 29.6634C36.4033 29.4929 35.8238 29.4077 35.1931 29.4077C34.159 29.4077 33.2187 29.6747 32.3721 30.2088C31.5255 30.7429 30.8522 31.5298 30.3522 32.5696C29.8522 33.6094 29.6022 34.885 29.6022 36.3963C29.6022 37.9077 29.8551 39.1833 30.3607 40.223C30.8664 41.2628 31.5511 42.0497 32.4147 42.5838C33.2783 43.1179 34.2499 43.385 35.3295 43.385C36.3295 43.385 37.2102 43.1719 37.9715 42.7458C38.7386 42.3139 39.3352 41.706 39.7613 40.9219C40.1931 40.1321 40.409 39.2031 40.409 38.135L41.0568 38.2713H35.8068V36.3963H42.4545V38.2713C42.4545 39.7088 42.1477 40.9588 41.534 42.0213C40.9261 43.0838 40.0852 43.9077 39.0113 44.4929C37.9431 45.0725 36.7158 45.3622 35.3295 45.3622C33.784 45.3622 32.4261 44.9986 31.2556 44.2713C30.0908 43.5441 29.1818 42.51 28.5283 41.1691C27.8806 39.8281 27.5568 38.2372 27.5568 36.3963C27.5568 35.0156 27.7414 33.7742 28.1107 32.6719C28.4857 31.5639 29.0141 30.6208 29.696 29.8423C30.3778 29.0639 31.1846 28.4673 32.1164 28.0526C33.0482 27.6378 34.0738 27.4304 35.1931 27.4304C36.1136 27.4304 36.9715 27.5696 37.767 27.848C38.5681 28.1208 39.2812 28.51 39.9062 29.0156C40.5369 29.5156 41.0624 30.1151 41.4829 30.8139C41.9033 31.5071 42.1931 32.277 42.3522 33.1236H40.1704Z",
    fill: "#ECECEC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_201_3120",
    x: 8.28467,
    y: 12.2371,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_201_3120"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_201_3120",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_201_3120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_201_3120",
    x1: 18.3093,
    y1: 57.8202,
    x2: 59.5189,
    y2: 75.5895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#697291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD7AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_201_3120",
    x1: 59.5001,
    y1: 43,
    x2: 20.2641,
    y2: 12.8595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292E3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#595F73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_201_3120",
    x1: 10.3756,
    y1: 27.0325,
    x2: 60.0119,
    y2: 46.1234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0846355,
    stopColor: "#4E83D2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16161D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigiforumStripe);
export default __webpack_public_path__ + "static/media/digiforum-stripe.af12f90f3338013b9c94f65ca3d44b16.svg";
export { ForwardRef as ReactComponent };